import {useLocation} from 'react-router-dom';
import {API_URL} from '../configuration/axios';

export const ADMIN_PANEL_PREFIX = '/admin';

export const findByIdApiUrlFromBrowserAdminPanelUrl: () => string = () => {
    const location = useLocation();

    return API_URL + location.pathname.slice(ADMIN_PANEL_PREFIX.length);
}